<!--
 * @Description: 云途-查看商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-07-07 10:07:42
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <div class="business-status-steps">
        <a-steps :current="stepIndex">
          <a-step
            v-for="item in stepsList"
            :key="item.value"
            :status="item.chanceStatus === 6||item.chanceStatus === 8 ? 'process' : ''"
            :title="item.label"
            :description="item.updateTime"
          />
        </a-steps>
      </div>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" tab="基本信息">
            <DetailViewForm ref="businessFormRef" title="基本信息" type="view" v-model:value="dataForm" :originalStatus="originalStatus" />
          </a-tab-pane>
          <a-tab-pane key="record" tab="跟进记录">
            <TabsClueCosFollowUp :permissionPage="permissionFollow" appId="cos_lbu" :chanceId="queryId" />
          </a-tab-pane>
          <a-tab-pane key="logs" tab="操作日志">
            <TabsOperationLog appId="cos_lbu" tableId="LbuBusinessOperationLog" :resourceId="queryId" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <SellerButton
        v-permission="'lbu_business_edit_btn'"
        controlType="none"
        :loading="loading"
        v-if="dataForm.status!=7"
        @click="handleEdit()"
        >编辑</SellerButton
      >
      <a-button v-permission="'lbu_business_write_follow_btn'" :loading="loading" @click="handleWriteFollowUp()"
        >写跟进</a-button
      >
      <a-popover placement="topRight" trigger="hover" color="#132043e5">
        <template #content>
          <dc-penetrate-content>
            <div class="business-status-popover">
              <a-radio-group
                v-model:value="status"
                style="width: 350px"
                :disabled="loading"
                @change="statusChange"
              >
                <a-radio v-for="item in waitingChangeStepList" :key="item.value" :value="item.value" :disabled="item.disabled">{{
                    item.label
                  }}</a-radio>
              </a-radio-group>
            </div>
          </dc-penetrate-content>
        </template>
        <a-button v-permission="'lbu_business_status_btn'" type="primary" :loading="loading">状态变更</a-button>
      </a-popover>
    </cos-footer-button>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import BusinessForm from './components/BusinessForm.vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { businessDetails, businessStatusRecord, businessChangeStatus } from '@/api/yuntuSales/chanceManage'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'
import DetailViewForm from '@/views/yuntuSales/chanceManage/business/components/DetailViewForm.vue'
import { useAreaStore } from '@/stores/area'

const router = useRouter()
const route = useRoute()
const permissionFollow = {
  edit: 'lbu_business_follow_edit_btn',
  del: 'lbu_business_follow_del_btn'
}

interface StatusStepItem {
  chanceStatus: number
  updateTime: string
  chanceId?: string
  label?: string
}

const queryId = computed(() => route.query.id as string)
const dataForm = ref<LbuBusinessEditParams>({})
const originalStatus = ref<number>()
const waitingChangeStepList = ref<any[]>([])
const areaStore = useAreaStore()
const paramCodeData = ref<{
  lbu_demand_country?: ParamCodeItem[]
  lbu_products?: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家
  lbu_products: [] // 出货渠道（云途产品）
})
// 获取业务参数
const getByParamCodes = () => {
  return new Promise((resolve) => {
    listByParamCodes({
      appId: 'cos_lbu',
      paramCodes: ['lbu_demand_country', 'lbu_products']
    }).then((res) => {
      paramCodeData.value = res.data
      resolve(res.data)
    })
  })
}

const stepsList = ref<any>([])
const successStep = {
  // label: '达到承诺业务量(SHIPPING TO PROFILE)',
  label: '06-达到承诺业务量',
  value: 7
}
const failStep = {
  // label: '不能合作(UNABLE TO GAIN)',
  label: '07-不能合作',
  value: 6
}
const futureStep = {
  // label: '未来机会(FUTURE OPPORTUNITIES)',
  label: '08-未来机会',
  value: 8
}
const getStatusSteps = () => {
  businessStatusRecord(queryId.value).then((res) => {
    if (!res.data || !res.data.length) return
    stepsList.value.forEach((item: any, i: number) => {
      const find = res.data.find((ele: StatusStepItem) => ele.chanceStatus === item.value)
      item.updateTime = find ? find.updateTime : undefined
      if (item.value === status.value) {
        stepIndex.value = i
      }
    })
  })
}
const status = ref<number>(1)
const stepIndex = ref<number>(1)
const getDetails = () => {
  return new Promise((resolve) => {
    businessDetails({ id: route.query.id }).then((res) => {
      status.value = res.data.status
      originalStatus.value = res.data.status
      if (!res.data.failedCooperateId) {
        res.data.failedCooperateId = undefined
      }
      if (!res.data.assistDepartment) {
        res.data.assistDepartment = undefined
      }
      dataForm.value = res.data
      formatLbu()
      resolve(res.data)
    })
  })
}
const initFn = async () => {
  await getDetails()
  getStatusSteps()
}
watch(
  () => status.value,
  () => {
    const currentStatus = status.value
    stepsList.value = businessStatusEnum.filter((item) => item.value < 6 || item.value === 9)
    if (currentStatus === 6) {
      stepsList.value.push(failStep)
    } else if (currentStatus === 8) {
      stepsList.value.push(futureStep)
    } else {
      stepsList.value.push(successStep)
    }

    // 编辑的时候，状态只能往下选
    // 未能合作6或者未来机会8 不受控制
    if (currentStatus === 6 || currentStatus === 8) {
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: ![0, 6, 8].includes(item.value) }))
    } else if (currentStatus === 7) {
      // 如果商机状态7达成承诺业务量，则不可变更为其他状态（新版【达到承诺业务量】商机状态可以变更为【不能合作】与【未来机会】）
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value !== 6 && item.value !== 8 }))
    } else if (currentStatus === 9) {
      // 准备发件
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < 5 || item.value === 5 || item.value === 7 }))
    } else {
      // 其余状态只可以向后变更
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < currentStatus || item.value === 4 || item.value === 9 || item.value === 5 || item.value === 7 }))
    }
    console.log(waitingChangeStepList.value)
  },
  { immediate: true }
)
onBeforeMount(async () => {
  await getByParamCodes()
  await areaStore.fetchData()
  initFn()
})

// 跳转编辑页面
const handleEdit = () => {
  router.push({ path: '/lbu/business/edit', query: { id: queryId.value } })
}
// 跳转写跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: { followRefId: dataForm.value.saleChanceRefId, chanceId: dataForm.value.id, returnPath: route.fullPath }
  })
}

const businessFormRef = ref()
const loading = ref(false)
const statusChange = (e: any) => {
  loading.value = true
  const params = {
    id: route.query.id as string,
    status: e.target.value
  }
  businessChangeStatus(params)
    .then(async () => {
      message.success('状态变更成功')
      initFn()
    })
    .catch(() => {
      status.value = dataForm.value.status || 1
    })
    .finally(() => {
      loading.value = false
    })
}

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

// 1. 先将树形结构扁平化，处理为同级
const flatTreeAndSetLevel = (tree: any, level = 1) => {
  const list: any[] = []
  tree.forEach((item: any) => {
    if (level === 1) item.parentId = 0 // 第一级设置父级id为0
    const o = JSON.parse(JSON.stringify(item))
    if (o.children) delete o.children
    o.level = level
    list.push(o)
    if (item.children && item.children.length) {
      list.push(...flatTreeAndSetLevel(item.children, level + 1))
    }
  })
  return list
}
// 2. 遍历上面扁平后的的数据，先根据id找出第一个，然后再根据它的parentId再找，直到找到parentId为0的为止，也是一个递归操作
const getParentName: any = (pid: number, list: any) => {
  let obj: any = null
  obj = list.find((item: any) => item.id === pid)
  if (obj && obj.parentId !== 0) return getParentName(obj.parentId, list)
  return obj
}
const formatLbu = () => {
  const result = []
  const list = dataForm.value.saleChanceName?.split(',')
  if (list && list.length) {
    const [originCountry, country, channel] = list
    const originCountryName = areaStore.area.find((item) => item.id === originCountry)?.name;
    result.push(originCountryName || originCountry)
    const countryName = paramCodeData.value.lbu_demand_country?.find(
      (item: ParamCodeItem) => item.id === parseInt(country)
    )
    const flatList = flatTreeAndSetLevel(paramCodeData.value.lbu_products)
    const channelName = getParentName(parseInt(channel), flatList)
    result.push(countryName?.name || country)
    result.push(channelName?.name || channel)
    dataForm.value.saleChanceNameByTxt = result.join('+')
  }
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuBusinessView' }
</script>

<style lang="scss" scoped>
.business-status-steps {
  margin-bottom: 20px;
  padding: 0 40px 20px;
  border-bottom: 1px solid #ebebeb;
  :deep(.ant-steps-horizontal) {
    .ant-steps-item-title {
      font-size: 14px;
    }
    &:not(.ant-steps-label-vertical) .ant-steps-item-description {
      max-width: 100%;
      font-size: 12px;
    }
  }
}
.ant-tabs {
  overflow: visible;
}
.business-status-popover {
  .ant-radio-group {
    padding: 4px 10px;
    border-radius: 4px;
    background-color: #fff;
  }
  .ant-radio-wrapper {
    color: #111;
  }
}
</style>
